import i18next from '../../config/i18next';
import i18nUser from './i18n/fr.json';
import TermsOfService from './pages/terms-of-service';

i18next.addResourceBundle('fr', 'terms-of-service', i18nUser);

export { TermsOfService };
